var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn-like",class:{liked: _vm.liked, anim: _setup.anim},attrs:{"title":_vm.$t(_vm.liked ? 'unlike' : 'like')},on:{"click":_setup.toggleLike}},[(_vm.liked)?_c('div',{staticClass:"icon icon-ic-favourite color-red"}):_c('div',{staticClass:"icon icon-ic-favourite-outline"})])
}
var staticRenderFns = []

export { render, staticRenderFns }